import { Provider } from "@models/interfaces";

export class PayoutProvider extends Provider {
	private send_enabled: boolean = false;
	public account_creation_enabled: boolean;

	public sendEnabled(sendEnabled: boolean): boolean {
		return this.send_enabled === sendEnabled;
	}
}
